import React from 'react';
import { useProduct } from '../ProductProvider';
import { Money } from '../Money';
/**
 * The `SelectedVariantPrice` component renders a `Money` component for the product's selected variant's price or compare at price.
 * It must be a descendent of a `ProductProvider` component.
 */
export function SelectedVariantPrice(props) {
    const product = useProduct();
    const { priceType = 'regular', ...passthroughProps } = props;
    if (product == null) {
        throw new Error('Expected a ProductProvider context, but none was found');
    }
    const selectedVariant = product.selectedVariant;
    const price = priceType === 'regular'
        ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2
        : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compareAtPriceV2;
    if (price == null) {
        return null;
    }
    return (React.createElement(Money, { ...passthroughProps, money: price }, props.children));
}
